import RepositoryInterface from "@/application/repositories/RepositoryInterface";
import httpRequest from "@/infra/httpRequest";
import CompanyDto from "@/application/dto/CompanyDto";

export default class CompaniesPagesRepository {

    public async getBySlug(slug: string): Promise<CompanyDto> {
        try {
            const { data } = await httpRequest.get(`/companies_pages/slug/${slug}`);
            return data;
        } catch (err) {
            throw Error;
        }
    }

    public async getCompanyUUID(companyName: string): Promise<any> {
        try {
            
        } catch (err) {
            return {};
        }
    }


}